module.exports = __webpack_public_path__ + "static/media/lst2icon.44d7095e.ico";